import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import ParkOverview from '@/views/ParkOverview'
import service from '@/views/service'
import ParkKeeper from '@/views/ParkKeeper'
import Community from '@/views/Community'
import detail from '@/views/detail'
import ProductCaseDetail from '@/views/ProductCaseDetail'
import BusinessCooperation from '@/views/BusinessCooperation'
import CompanyProfile from '@/views/CompanyProfile'
import HonoraryCertificate from '@/views/HonoraryCertificate'
import DataDownload from '@/views/DataDownload'
import ContactUs from '@/views/ContactUs'

import Token from '@/views/Token'
import TokenCompanyProfile from '@/views/Token/CompanyProfile'
import TokenAIVideo from '@/views/Token/AIVideo'
import TokenAIComic from '@/views/Token/AIComic'
import TokenWatermarkRemoval from '@/views/Token/WatermarkRemoval'
import TokenMusicGeneration from '@/views/Token/MusicGeneration'
import TokenComputingPower from '@/views/Token/ComputingPower'

Vue.use(Router)

const originalPush = Router.prototype.push
    // 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    // mode: 'history',
    routes: [{
            path: '/', //首页
            name: 'Index',
            component: Index,
            meta: {
                requiresAuth: true,
            },
        },

        {
            path: '/ParkOverview', // 动态
            name: 'ParkOverview',
            component: ParkOverview,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/service', // 技术服务
            name: 'service',
            component: service,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/ParkKeeper', //产品展示
            name: 'ParkKeeper',
            component: ParkKeeper,
            meta: {
                requiresAuth: true,
            }
        },

        {
            path: '/Community', // 关于我们
            name: 'Community',
            component: Community,
            redirect: '/Community/CompanyProfile',
            children: [{
                    path: '/Community/CompanyProfile', // 公司简介
                    name: 'CompanyProfile',
                    component: CompanyProfile,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {

                    path: '/Community/HonoraryCertificate', // 荣誉资质
                    name: 'HonoraryCertificate',
                    component: HonoraryCertificate,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {

                    path: '/Community/DataDownload', // 资料下载
                    name: 'DataDownload',
                    component: DataDownload,
                    meta: {
                        requiresAuth: true,
                    }
                },

                {

                    path: '/Community/ContactUs', // 联系我们
                    name: 'ContactUs',
                    component: ContactUs,
                    meta: {
                        requiresAuth: true,
                    }
                },
            ],
            meta: {
                requiresAuth: true,
            }
        },

        {
            path: '/Token',
            name: 'Token',
            component: Token,
            redirect: '/Token/CompanyProfile',
            children: [
                {
                    path: '/Token/CompanyProfile',
                    name: 'TokenCompanyProfile',
                    component: TokenCompanyProfile,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/Token/AIVideo',
                    name: 'TokenAIVideo',
                    component: TokenAIVideo,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/Token/AIComic',
                    name: 'TokenAIComic',
                    component: TokenAIComic,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/Token/WatermarkRemoval',
                    name: 'TokenWatermarkRemoval',
                    component: TokenWatermarkRemoval,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/Token/MusicGeneration',
                    name: 'TokenMusicGeneration',
                    component: TokenMusicGeneration,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/Token/ComputingPower',
                    name: 'TokenComputingPower',
                    component: TokenComputingPower,
                    meta: {
                        requiresAuth: true,
                    }
                },
            ],
            meta: {
                requiresAuth: true,
            }
        },

        {
            path: '/detail', //富文本详情
            name: 'detail',
            component: detail,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/ParkKeeper/ProductCaseDetail', //产品案例详情
            name: 'ProductCaseDetail',
            component: ProductCaseDetail,
            meta: {
                requiresAuth: true,
            }
        },

        {
            path: '/BusinessCooperation', // 方案展示
            name: 'BusinessCooperation',
            component: BusinessCooperation,
            meta: {
                requiresAuth: true,
            }
        },


    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js